import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { FRICTION_STATUSES } from '@trevize/operators'

import { DefaultLoader } from '#components/default-loader.tsx'
import { FrictionPage } from '#features/friction/friction-page.tsx'

const searchSchema = z.object({
  tab: z
    .enum(['active', 'resolved', 'dismissed'])
    .catch('active')
    .default('active'),
  scope: z.enum(['repo', 'environment']).optional().catch(undefined),
  status: z.array(z.enum(FRICTION_STATUSES)).optional().catch(undefined),
  repo: z.string().optional().catch(undefined),
  item: z.string().optional().catch(undefined),
})

export const Route = createFileRoute('/_app/$workspace/_dashboard/friction/')({
  component: FrictionPage,
  pendingComponent: DefaultLoader,
  validateSearch: searchSchema,
})
